import { apiRequest } from '../../ConversationPage/apis/client';

import { BookingApiKey, AddApiKeyRequest, ToolName } from './types';

// Get all booking API keys for authenticated user
export const getBookingApiKeys = async (token: string): Promise<BookingApiKey[]> => {
  return apiRequest<BookingApiKey[]>({
    endpoint: '/booking-api-keys',
    method: 'GET',
    token,
  });
};

// Add or update API key for a tool
export const addBookingApiKey = async (
  data: AddApiKeyRequest,
  token: string
): Promise<BookingApiKey> => {
  return apiRequest<BookingApiKey>({
    endpoint: '/booking-api-keys',
    method: 'POST',
    body: data,
    token,
  });
};

// Remove API key for specific tool
export const deleteBookingApiKey = async (
  toolName: ToolName,
  token: string
): Promise<{ message: string }> => {
  return apiRequest<{ message: string }>({
    endpoint: `/booking-api-keys/${toolName}`,
    method: 'DELETE',
    token,
  });
};
